/* eslint-disable react-refresh/only-export-components */
import React, {
  createContext,
  createRef,
  useRef,
  useContext,
  useEffect,
} from 'react';

const ScrollContext = createContext();
const prizeRef = createRef();

export const ScrollContextProvider = props => {
  const postRefs = useRef([]);

  useEffect(() => {
    props.posts.forEach(post => {
      postRefs.current[post.uuid] = React.createRef();
    });
  }, [props.posts]);

  return (
    <ScrollContext.Provider value={{ prizeRef, postRefs }}>
      {props.children}
    </ScrollContext.Provider>
  );
};

export const useScrollContext = () => useContext(ScrollContext);
